<template>
  <AlertsChip
    :alerts="alerts"
    @alert-action="onAction"
    @alert-dismiss="onDismiss"
    @view-all="router.push({ path: '/inicio', query: { alertas: '1' } })"
  />
</template>

<script setup>
// Chip de alertas para los encabezados de Contratos, Cobranza, Finanzas, Mantenimiento y Servicios.
// Trae las alertas del parque por su cuenta; "Ver todas" lleva al panel principal con la lista completa abierta.
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import AlertsChip from '@/components/Panel/AlertsChip.vue'
import { getParkAlerts, dismissAlert } from '@/services/alerts'
import { ALERT_ROUTES } from '@/services/alertRoutes'

const props = defineProps({ parkId: { type: String, default: null } })
const router = useRouter()
const alerts = ref([])

watch(
  () => props.parkId,
  async (id) => {
    if (!id) return
    try {
      alerts.value = await getParkAlerts(id)
    } catch {
      alerts.value = [] // sin acceso a las alertas o sin conexión: el chip simplemente no aparece
    }
  },
  { immediate: true },
)

async function remove(alert) {
  alerts.value = alerts.value.filter((a) => a.key !== alert.key)
  try {
    await dismissAlert(props.parkId, alert.key)
  } catch {
    alerts.value = [...alerts.value, alert]
  }
}

async function onAction(alert) {
  await remove(alert)
  const build = ALERT_ROUTES[alert.actionType]
  if (build) router.push(build(alert.actionPayload || {}))
}

const onDismiss = (alert) => remove(alert)
</script>